import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="700pt" height="700pt" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M175 280c0 19.328 15.672 35 35 35s35-15.672 35-35-15.672-35-35-35-35 15.672-35 35zM350 315c-19.328 0-35-15.672-35-35s15.672-35 35-35 35 15.672 35 35-15.672 35-35 35zM490 315c-19.328 0-35-15.672-35-35s15.672-35 35-35 35 15.672 35 35-15.672 35-35 35z" /></svg>;